// extracted by mini-css-extract-plugin
module.exports = {"radio":"_12834"};